module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2a"
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }), _c('a', {
    attrs: {
      "id": "sec17"
    }
  }), _vm._v("ARTICULATIONS OF ARTIFICE IN THE WORK OF MARY JO BANG")]), _vm._v(" "), _c('p', {
    staticClass: "author2"
  }, [_c('a', {
    attrs: {
      "id": "sec18"
    }
  }), _c('em', [_vm._v("Karla Kelsey")])]), _vm._v(" "), _c('div', {
    staticClass: "blockquotez"
  }, [_c('div', {
    staticClass: "blockquotez"
  }, [_c('div', {
    staticClass: "blockquotez"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("Then I went home"), _c('br'), _vm._v("And wrote a script"), _c('br'), _vm._v("To follow where I got a free boat ride"), _c('br'), _vm._v("While taking pictures of pictures"), _c('br'), _vm._v("And all the pictures came out beautiful."), _c('a', {
    attrs: {
      "id": "en1"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en_1"
    }
  }, [_c('sup', [_vm._v("1")])])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_vm._v("A "), _c('span', {
    staticClass: "small"
  }, [_vm._v("POET OF PERSONA")]), _vm._v(", of film and stage metaphor, of persistent eye for visual detail—of insistence that we “look” and “look” once again"), _c('a', {
    attrs: {
      "id": "en2"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en_2"
    }
  }, [_c('sup', [_vm._v("2")])]), _vm._v("—Mary Jo Bang’s six books turn on articulating the artifice of the lyric. Like the photographs of Cindy Sherman, an artist directly evoked in Bang’s statement of poetics and in her ekphrastic poem “Untitled # 70 (Or, the Question of Remains),” Bang’s work hinges on drawing attention to the dyadic nature of signs, the unpassable separation between signifier and signified that are separate elements, but also two sides of the same coin. Although each of Bang’s books has a specific nature, in every project Bang conjures up surfaces, absorbing readers in vivid tableaux while exposing the constructed nature of imaginative objects.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The concept of the dyadic sign becomes particularly relevant when conceptual components are most submerged, as in media such as photography and language where the meaning of the sign is often mistakenly assumed to be a real-world referent. Artists such as Cindy Sherman and Mary Jo Bang problematize the impulse to fix meaning in this way. For example, when we look at any of Sherman’s sixty-nine black-and-white photographs in her "), _c('em', [_vm._v("Untitled Film Stills")]), _vm._v(" series we first think we are looking at publicity pictures of an actress-in-character, taken from films made in the ’60s and ’70s. Here we see a blonde bombshell playing the role of a woman lounging in her bedroom, peignoir thrown open, eyes fluttered up to the ceiling (“Untitled Film Still #6”). In another an actress poses as the quintessential sexy librarian reaching for a book (“Untitled Film Still #13”)."), _c('a', {
    attrs: {
      "id": "en3"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en_3"
    }
  }, [_c('sup', [_vm._v("3")])]), _vm._v(" On first glance, we will assume that what the pictures “mean”—what they are “of”—is an actress caught in the act of posing in character. However, this is not the case. What is true of the photographs is that they all feature the artist herself, dressed up as the different female characters an actress from that era was most often asked to play. Understanding this reveals the extent to which the viewer’s narrative about the blonde bombshell was not in the "), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }), _vm._v("pictures themselves—for there was no blonde bombshell, merely an artist pretending to be someone else—but rather in the conceptual context we bring to our viewing. In addition, due to the fact that the photographs feature the artist herself, we are given to wonder who is literally behind the camera. As we look at the photographs we realize that we are assuming the point of view of somebody’s gaze—but whose?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Sherman’s work is unique because it draws us into a fantasy, asking us to indulge in the sensuous surface of images while, at the same time, complicating the way that they evoke meaning. Further, even when the method of the series is revealed, and we realize that we are looking at a commentary on the genre of film stills rather than at film stills themselves, their sensuous artifice continues to beckon: The woman in the photos still has wet, pouty lips, a coy glance as she turns to walk away. As we will see, Mary Jo Bang’s work takes us through a very similar trajectory. There is always the lyric "), _c('em', [_vm._v("and")]), _vm._v(" attention to what constructs lyric surface—material language as well as mental image, association, response. Bang’s poems, like Sherman’s photographs, act as frames, embodying both signifier and signified, asking readers not only to engage with what is represented, but also to inspect each representation as something artfully constructed from multiple sources.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Such articulation of artifice defines Mary Jo Bang’s position in the landscape of contemporary poetry, for, in many respects, a poet’s relationship to lyric surface places him or her upon an ever-contentious continuum. On one end of the spectrum is the New Critical lyric, which values circumscribed utterance and the absorbent voice of a single, unified speaker overheard in the midst of an emotional moment."), _c('a', {
    attrs: {
      "id": "en4"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en_4"
    }
  }, [_c('sup', [_vm._v("4")])]), _vm._v(" Such work seeks to create a continuous dream of reading wherein the surface of language falls away and the reader becomes seeped in a moment of unmediated experience. Optimally, all of the poetic elements used in a single lyric—figurative language, diction, form, etc.—are crafted within the space of its emotional arc, feeding back into the central core of the poem. As such, the New Critical lyric is highly constructed but asks to be read as transparent window opening upon interior and exterior landscape rather than artificial—made—object.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On the other end of the spectrum, avant-garde writers have long been suspicious of such absorbent landscapes and repeatedly draw attention to the linguistic nature of the poetic object, outlining the construction of subjectivity and the objects, ideas, and emotions the poem articulates. Charles Bernstein’s essay “Artifice of Absorption” characterizes such work as that which draws attention to artifice, rather than submerging it, through the use of “exaggeration, attention scattering, distraction, digression, interruptive, transgressive, undecorous, anticonventional, baroque, camp, decorative.”"), _c('a', {
    attrs: {
      "id": "en5"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en_5"
    }
  }, [_c('sup', [_vm._v("5")])]), _vm._v(" Work on this end of the spectrum draws attention to the "), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }), _vm._v("impermeability of language, insisting that the experience of the poem is an experience of reading.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("These divisions are, themselves, of course, artificial, for the lyric has always depended on the tension between absorption and attention to surface. Likewise, Bernstein insists that "), _c('em', [_vm._v("all")]), _vm._v(" poetics imply artifice, and he cites Helen Vendler, among others, to show that artifice is a recognized aspect of the tradition, even on the conservative end of the spectrum. He quotes Vendler’s statement that “the symbolic strength of poetry consists in giving presence, through linguistic signs, to absent realities while insisting, by the very brilliance of poetic style, on the linguistic nature of its own being and the illusionistic character of its effects.”"), _c('a', {
    attrs: {
      "id": "en6"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en_6"
    }
  }, [_c('sup', [_vm._v("6")])]), _vm._v(" The crux of the issue is whether or not a poem admits to its artifice, and to what end. For the New Critical lyric, the exposure of artifice is considered artistic flaw. For the avant-garde writer, not to expose artifice is considered ethical flaw, and today’s poetic climate is hyperconscious of this duality. As Susan Schultz has suggested, “Lyric poets (because there are always such) must find ways in which to accommodate the lyric to the actual world, where voice does not denote mastery so much as conflict, identity so much as its confusions and contradictions.”"), _c('a', {
    attrs: {
      "id": "en7"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en_7"
    }
  }, [_c('sup', [_vm._v("7")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If we take even the most basic definition of the lyric as a short poem—a poem short enough to be held in the mind—we will see that the genre itself admits contradiction, for regardless of how short a poem might be its multiple meanings happen simultaneously, eluding the grasp of the mind’s moment. Take, for example, Bang’s one-line poem “B Is for Beckett,” from her most recent book "), _c('em', [_vm._v("The Bride of E")]), _vm._v(". The poem reads, in its entirety: “There is so little to say.”"), _c('a', {
    attrs: {
      "id": "en8"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en_8"
    }
  }, [_c('sup', [_vm._v("8")])]), _vm._v(" On the one hand, this utterance can be held in the mind all at once. It is composed of only six words and it does not even require imagining a visual image. However, once we begin to think about the poem, the mind begins to trace ever-outward and the utterance shows itself to be uncontainable.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As we think through the poem, we see that the title of the poem rewrites the familiar alphabet instruction, “B is for ball,” thus re-instructing us in the attachments of association, giving us an adult existential primer, a little glimpse of the way Bang’s own mind associates. We toggle the “for” from “stands for” to “is for”—into a dedication. This poem, this B, is for Beckett. A whole page, one sentence, just for him. A whole page, just one sentence, feels apt: “There is so little to say,” alone on the page as a poem, is so very Beckett that it might have been said by Beckett. But the phrase is also a response to the end of his play, "), _c('em', [_vm._v("Ohio, Impromptu")]), _vm._v(", which finishes: “There is nothing left to tell.”"), _c('a', {
    attrs: {
      "id": "en9"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en_9"
    }
  }, [_c('sup', [_vm._v("9")])]), _vm._v(" Readers familiar with Bang’s work, knowing that the title of her third book, "), _c('em', [_vm._v("The Downstream Extremity of the Isle of Swans")]), _vm._v(", is lifted from "), _c('em', [_vm._v("Ohio, Impromptu")]), _vm._v(", will feel additional resonance.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Thinking further and comparing the phrases now in our minds, the subtle "), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }), _vm._v("difference between “telling” and “saying” crackles with significance. “Telling” connotes a relationship with a listener; “saying” has undertones of personal reservoir. Here there is a tremendous gap between there being “so little” to say and “nothing left” to tell. "), _c('em', [_vm._v("Because")]), _vm._v(" of Beckett’s work, we have a little to say—not nothing. We have followed his direction, have gone on when we couldn’t go on, and so, by his lead, he has, in some small part, delivered us from nothing. At the same time, we might take a different track with the poem, and come to the idea that because Beckett has said everything worth saying—has said most of what there is to say about existence—there is now “so little to say.” All that is left is a linguistic shrug. A one-line poem to add to, to nod to, all that is Beckett.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I have spun this small poem out to great distance as model for the way Bang’s work asks to be read and unfolded, cross-checked across books, both hers and others. From her first book to her most recent projects, the experience of Bang’s work is visually and aurally sensual while being, at the same time, conceptual, for here the physical and the mental—the abstract and the concrete—are equal and necessary parts of the dyad of reading. As in “B Is for Beckett,” the tension is between absence and presence, between the words articulated on the page and the ideas, connotations, associations, and references that come with their signification. This is stimulating territory, for once we enter the dream of the lyric, it seems that to both engage imagination in the work’s “content” while bringing to the surface the constructed nature of its being, is an irreconcilable contradiction. But instead of turning away from such difficult questions and seeming contradictions, Mary Jo Bang’s work thrives in such a space.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bang engages this tension by transforming the New Critical speaker into persona and the representational dream of objects into strange, vivid signs that continue to come back across books. Familiar signs accrete new meanings as they work across texts: Mickey Mouse appears as a watch, a balloon, a character that speaks and dances. Lewis Carroll’s Alice writes in her “Rite as Reign notebook,” and later she refuses to appear in a poem. Needle-necked swans surface and swim under. Louise, from Bang’s second book, "), _c('em', [_vm._v("Louise in Love")]), _vm._v(", appears carrying a copy of "), _c('em', [_vm._v("Mrs. Dalloway")]), _vm._v(", foreshadowing a current project of constructing poems out of Woolf’s text. Rather than rejecting the lyric as a false thing, Bang turns into its façade, articulating the way in which lyric illusion functions. Her work ultimately shows that we owe the dynamism of the lyric to this tension—a tension that has necessarily always existed in its defining elements.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Indeed, Bang’s headlong movement into absorption in artifice while at the same time revealing the poem’s construction defines the way in which her work differs from many other writers working within the lyric tradition. This stance of lyric tension is rare in the contemporary landscape where, even though poets borrow from both lyric and experimental "), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }), _vm._v("traditions, these two actions are often perceived as being mutually exclusive with mutually exclusive ends. As Bernstein notes, “if the artifice is recessed, the resulting textual transparency yields an apparent, if misleading content . . . if the artifice is foregrounded, there’s a tendency to say that there is no content or meaning.”"), _c('a', {
    attrs: {
      "id": "en10"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en_10"
    }
  }, [_c('sup', [_vm._v("10")])]), _vm._v(" For the remainder of this essay I will focus on this aspect of lyric tension by concentrating on Bang’s three most recent books—"), _c('em', [_vm._v("The Eye Like a Strange Balloon")]), _vm._v(", "), _c('em', [_vm._v("Elegy")]), _vm._v(", and "), _c('em', [_vm._v("The Bride of E")]), _vm._v("—for these books foreground not only artifice, but the role that language plays in constructing the realities in which we absorb ourselves. However, because of the intertextual nature of Bang’s work, it is important to set these volumes within the context of her first three books. To this end, I will briefly introduce the interplay of artifice and absorption in her early writing before looking at her more recent projects.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("VIDENT")]), _vm._v(" in Bang’s first book, "), _c('em', [_vm._v("Apology for Want")]), _vm._v(", are obsessions and gestures found throughout her work. There is a preoccupation with death, both overtly named and figured. There is obsession with the material, often textile-based details of life forged in the foundry of looking. Here we find high art along with the colloquial. There is the stall of silence at the edge of each line while, at the same time, enjambed sentences rush to fill the space with speech. There is the frank tone of a solitary voice, the sense of a real person speaking in language that here softens with longing, there sharpens with wit. And everywhere there are objects, of art and of everyday life, staring back at us, gleaming. However, out of all of Bang’s books, "), _c('em', [_vm._v("Apology for Want")]), _vm._v(" most closely follows the conventions of the New Critical lyric and, therefore, pushes the artifice of each poem into the background whereas—in later work—she focuses on drawing attention to the surface. As a result of these conventions, in this first book the dream of the lyric is rarely disrupted—we are thoroughly absorbed. Nevertheless, within this smoothness we see the preoccupation with precise and particular imagery that prefigures Bang’s work with the constructed nature of the art image in "), _c('em', [_vm._v("The Eye Like a Strange Balloon")]), _vm._v(". In addition, "), _c('em', [_vm._v("Apology for Want")]), _vm._v(" recycles moments of its own imagery across different poems. This action prompts the reader to begin to see the poem-as-art-object, as something made with language, rather than as pure subjective utterance.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("While "), _c('em', [_vm._v("Apology for Want")]), _vm._v(" lends itself to being read as the intimate thoughts of a single speaker, Bang’s second book, "), _c('em', [_vm._v("Louise in Love")]), _vm._v(", actively prohibits such approaches to reading by setting up a fictive scenario populated by highly artificial characters. The book revolves around Louise, a woman in love who both is and is not the actress Louise Brooks. She dresses and sighs with all of the accoutrements of a silent-era star, yet there is little to no context to Bang’s character beyond what happens in each tableau-like scene, which prohibits us from reading this as historical work. "), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }), _vm._v("This status of being and not being a particular identity is fundamental to the mode of the book and the way in which Bang uses persona to foreground artifice. As soon as readers become comfortable with a particular notion of who and what Louise represents, Bang turns the figure, opening her up to other interpretations, asking us to see her—and her story—as a series of literary devices that fail to hold together into a singular speaker or a single, integrated subject. As Stephen Burt has suggested, in "), _c('em', [_vm._v("Louise in Love")]), _vm._v(", such tactics of foregrounding artifice are not merely a fashionable response to contemporary cynicism about the rhetoric of love and beauty—about the rhetoric of self. Instead, artifice is the very tactic that “enables a love affair.”"), _c('a', {
    attrs: {
      "id": "en11"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en_11"
    }
  }, [_c('sup', [_vm._v("11")])]), _vm._v(" Rather than seeing Bang’s insistence on artifice as something that she adds to her narrative like a voice-over or coloration of the real, Burt suggests that such artifice is part of the way we make it through everyday life.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("The Downstream Extremity of the Isle of Swans")]), _vm._v(", Bang’s third book, takes this notion of artifice and deepens it beyond the realm of a love affair, into the gut of humanity’s existential state. At the core of the book there is a realization that we can never know or see what goes on in another person’s mind, and in this sense, we are always navigating a constructed experience, mediated by the other’s presentation of self, and by our own assumptions. With this book, Bang unmoors her work from the safety of concrete, finite content and addresses concerns that—like those of her later projects—are much more abstract and foreground modes of representation, rather than the “content” of what is represented. For example, in "), _c('em', [_vm._v("Downstream Extremity")]), _vm._v(", notions of the stage, acting, theater, and drama are developed and maintained, but without the anchor of the fictional background that they have in "), _c('em', [_vm._v("Louise")]), _vm._v(". Instead of existing as part of a narrative world that more or less mirrors our own, these elements express the artifice implicit in our acts of figuring.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In addition to developing metaphors of film and theater that inform her subsequent work, "), _c('em', [_vm._v("Downstream Extremity")]), _vm._v(" develops two other tactics that are carried through Bang’s later books. Heavy sound play, often in the form of alliteration as in the “picturesque—pretty pipers piped // against a backdrape of pineapple yellow” in the poem “The Beauties of Nature,”"), _c('a', {
    attrs: {
      "id": "en12"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en_12"
    }
  }, [_c('sup', [_vm._v("12")])]), _vm._v(" draws our attention to extralexical aspects of poetic language that do not fold into traditional notions of semantic meaning. Such attention directs us to the material substance of language and the way that sound, as well as sense, works to hold a poem together. Allusion, the second tactic, here most noticeably ties the book to Beckett—but also to Shakespeare in a poem titled “It’s Winter in the Eye, and Like Ophelia” and to Elizabeth Bishop (Bang’s lines “the too-heavy hair, long with cool stars—pin pricks / in a watery bed sheet”"), _c('a', {
    attrs: {
      "id": "en13"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en_13"
    }
  }, [_c('sup', [_vm._v("13")])]), _vm._v(" echo Bishop’s poem “The Shampoo”)—and to Wallace Stevens, clearly evoked in the lines “Who will catch the "), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }), _vm._v("windmill’s palm frond in a summer storm? / O the idea of order. It will be seen through.”"), _c('a', {
    attrs: {
      "id": "en14"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en_14"
    }
  }, [_c('sup', [_vm._v("14")])]), _vm._v(" These strategies mark Bang’s increasing turn into the articulation of artifice, for they disrupt the careful New Critical illusion of a speaker overheard uttering the most private of individual thoughts. By performing such uttering in wrought, sound-heavy language that employs the figures of other writers, Bang throws the dynamics we assume to be true of the lyric into question.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UBLISHED")]), _vm._v(" in 2004, "), _c('em', [_vm._v("The Eye Like a Strange Balloon")]), _vm._v(" consists entirely of ekphrastic poems, and the book moves through a select history of art including Sigmar Poke, Willem de Kooning, and Cindy Sherman. Organized in reverse chronological order, the book begins with a poem based on a 2003 work of art by Bruce Pearson and moves backward through time. The penultimate poem is based on an untitled first-century bc Samarian fragment. And, as if to completely fulfill the notion that “Art is what looking takes you to”—a phrase from the poem “High Art”—the last poem of the book reverses the process of ekphrastic making: Bang wrote “What Moonlight Will Do for Ruins,” and then created her own piece of visual art after the poem.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In presenting us with representations of representations, "), _c('em', [_vm._v("The Eye Like a Strange Balloon")]), _vm._v(" operates as lyric cousin to Roland Barthes’s "), _c('em', [_vm._v("Camera Lucida")]), _vm._v(", a book of great importance to Bang. In this work, Barthes spins out the story of how we make photographs mean. Photography, like language, is a tricky medium because viewers, like readers, tend to equate the meaning of a photo with the figure that it represents, ignoring the art of the lens and the context of the photo’s making and viewing. Like Barthes, Bang’s book seeks to draw our attention to the lens. Traversing the visual landscape of Bang’s book, we are struck by the many modes of invention that attach a thing to its representation, meaning to world and word.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bang’s study of the way narrative and thought attach to image dates back to her training as a visual artist. While working on a BA in photography in London, Bang became fascinated with the way in which, even in photojournalism, the relationship between image and narrative is constructed. As Bang relates, in one project she appropriated photographs from")]), _vm._v(" "), _c('div', {
    staticClass: "blockquotez"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("the Farm Security Administration in the 1930s, where you have people like Dorothy Lange and James Agee and Walker Evans going out and taking these so-called documentary photographs that have come to represent the “reality” of a particular era in a well-defined geographical region in America."), _c('a', {
    attrs: {
      "id": "en15"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en_15"
    }
  }, [_c('sup', [_vm._v("15")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("She made changes to the original photographs (such as inserting Mickey Mouse into barren landscapes, or perching the Cheshire cat in a tree) and re-photographed them. Her impulse to do so came from learning that the "), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }), _vm._v("original FSA photographers were sent out with scripts and told to take photos to match. When the scripts led to images that were too poverty-stricken to correlate with America’s idea of itself, the government revised the scripts and asked for a more acceptably middle-class range of images. By inserting pop culture icons into such images, Bang asked her viewer to question the transparent frame they had been given, gesturing toward the fact that each act of looking is undergirded by narrative and idea.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("The Eye Like a Strange Balloon")]), _vm._v(" operates directly within this lineage: The visual art behind the book serves less as palate of objects set out for description and more as objects that trigger lines of meditation, narrative, description, and association investigating the “how” of attachment. And while the work encompasses the ekphrastic tradition of representing in words what has been rendered on canvas, in marble, as tapestry, with projection, the book is always also interested in performing and questioning the ways in which such representation comes to be and mean. As Donna Stonecipher remarks in a review of the book,")]), _vm._v(" "), _c('div', {
    staticClass: "blockquotez"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("the poems . . . are full of eyes, mirrors, cameras, lenses, monocles, microscopes, and blind people. There are also repeated references to scenes, sequences, televisions, stages, operas, and films—all forms of constructed experience that the eye watches. The eye, therefore, is complicit in the artificializing of experience through its representation."), _c('a', {
    attrs: {
      "id": "en16"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en_16"
    }
  }, [_c('sup', [_vm._v("16")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The interest, here, is not to transparently render, but to carry across the sensation of looking and the act of mind as it connects. As such, "), _c('em', [_vm._v("The Eye Like a Strange Balloon")]), _vm._v(" works both within and against the mimetic assumption of ekphrastic work, mining the questions and beliefs that any viewer might hold about the artifice of representation.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We need only to look at the title of the collection to see these tensions at play. The phrase “The Eye Like a Strange Balloon” is a translation of part of the title of a painting by Odilon Redon—“L’oeil, comme un ballon bizarre se dirige vers l’infini.” It is also the title of one of the poems of the book. As such, we begin with a complexed sign. In addition, the cover of the book does not reproduce the Redon painting; instead, the cover is a photograph of a girl in a red dress holding, in front of her face, a big, smiley-faced, yellow balloon. We see value placed on metaphor (the eye is likened to the balloon) and a curious absence of verb—it is easy to miss-see and mis-hear the title as “The eye is like a strange balloon” rather than the fragmented sentence, which leaves us wondering what the predicate of the sentence might be. Additionally, the visual pun of the cover images helps us to read “The Eye” as “the I”—the I as an ever-familiar emoticon-turned-balloon filled with air and masking the face. The “I” as a Redon painting, as a book of poems, as a poem, as a smiling simile waiting to be released into air.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_42"
    }
  }), _vm._v("This restless quality of engagement permeates the entire volume, marking the work as part of a contemporary, alternative tradition of ekphrastic writing. In an article about Cole Swensen’s ekphrastic book "), _c('em', [_vm._v("Try")]), _vm._v(", Lynn Keller outlines this tradition in terms that apply to "), _c('em', [_vm._v("The Eye Like a Strange Balloon")]), _vm._v(". The conventions of ekphrastic writing have the writer stand at a distance from the work of art, creating a verbal representation of a visual work that represents an object in the world. In the alternative tradition Keller delineates, writers such as Swensen (and, I contend, Bang) re-vision the tradition by setting themselves inside and within the work of art—“living with the art,” as Swensen says of her work."), _c('a', {
    attrs: {
      "id": "en17"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en_17"
    }
  }, [_c('sup', [_vm._v("17")])]), _vm._v(" In this way, such ekphrastic work is less about representing an object that is itself a representation, and more about exploring the abstract questions and connections that exist among and between modes of rendering.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("One of the ways that Bang effects this task is by taking on the persona of figures depicted in the artwork, exploring the way in which narrative is constructed from fragments and is, itself, never complete. Bang’s “Mrs. Autumn and Her Two Daughters,” after Sigmar Polke’s 1991 “Frau Herbst und ihre zwei Töchter,” is one such work. As with other poems in the book, “Mrs. Autumn” takes its mode directly from the cues of the visual work. The painting asks for narrative, for it is dominated by a trio of black-and-white figures that are immediately recognizable as “Mrs. Autumn and Her Two Daughters.” Dressed in Victorian garb, the women, perched on a cloud, are busy making snow. The mother and one of the daughters wear capes and wield oversized sheers, as the second, capeless daughter leans over the edge of the cloud, scattering snow. While there are other things going on in the painting (below the cloud is a miniature mountain, a man on a horse—and the figurative images are, themselves, layered over a background pattern), Polke draws our attention to this trio of women by placing them in the upper left hand corner of the pictorial plane—the place that Western “readers” go to automatically. The figures are much larger and darker than the sketch-like characters below and clearly center our experience.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If the figures in the painting aren’t enough to inspire a narrative reading of the work, the painting’s title attaches the image to the frame of a story. The trio is not just any trio, but forms a family portrait "), _c('em', [_vm._v("sans")]), _vm._v(" father. The mother is the only one with a proper name, and her name dubs her “wife” (“Mrs.”) and gestures toward allegory (“Autumn”). The other two figures are undifferentiated from each other in the title (mere “Daughters”) and look visually similar to each other. Thus, the triggering occasion for the narrative nature of the poem is twofold. The speaker of the poem immediately identifies herself as one of the daughters, and the course of the poem is spent in a struggle to voice differentiation: “My sister wears ermine. I have a narrow waist” and “I love my sister but hate my mother” and “One "), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }), _vm._v("of us is not like our mother and it’s me. It’s I.”"), _c('a', {
    attrs: {
      "id": "en18"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en_18"
    }
  }, [_c('sup', [_vm._v("18")])]), _vm._v(" With subtle gestures, such as this moment of syntactical revision from “it’s me” to the correct “It’s I,” Bang foregrounds the way in which language for identity creates identity.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In addition to the speaker’s overt articulation of identity-making, the details of the poem foreground narrative invention rather than taking the existence of any given narrative for granted. In doing so, Bang suggests that our stories depend on the details we select for telling, and by comparing the visual image with Bang’s poem we become aware of just how much is made in the act of looking. As Bang explains in an interview, “It turns out that the world is a fiction from the point of view of any written ‘I’ or ‘you’ or ‘she.’ It’s a fiction because it is selective, and depending on what is selected, that becomes the story.”"), _c('a', {
    attrs: {
      "id": "en19"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en_19"
    }
  }, [_c('sup', [_vm._v("19")])]), _vm._v(" We see this at work in the poem, revealed in such moments as “We still live where you last left us—/ between the palace where you keep your winter / and the summer garden of the ersatz emperor.” The speaker-daughter’s address to an absent “you” (perhaps the father, perhaps the viewer) gestures outside the frame of the painting, but also gives us a context for the figures: “White washes // over me. I do not act / like my mother. I lean farther.” Concrete detail becomes metaphor as we toggle back and forth between what is on canvas and what is said. As such, the poem comments on the formative properties of looking, of circumscribing oneself as object in a narrative-image-based field. In this way, the poem functions similarly to work done in "), _c('em', [_vm._v("Louise in Love")]), _vm._v(": As a reader we are invited to fall in love with Louise, but we are also consistently reminded that she is an aesthetic object, a made work of fiction.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In contrast to the landscape of story present in “Mrs. Autumn,” “High Art” is a poem of “Atmospherics predominating // over drama.”"), _c('a', {
    attrs: {
      "id": "en20"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en_20"
    }
  }, [_c('sup', [_vm._v("20")])]), _vm._v(" Instead of foregrounding the narrative of finding ourselves in the more-or-less fully formed images society throws at us, “High Art,” written after the feature film by Lisa Cholodenko, foregrounds the messy, disjunctive constellation of action that results in these clean-seeming surfaces. The fact that Bang uses a movie to catalyze the poem makes sense: We go to see a movie and watch the plot unfold in a perfectly uniform pace of cause and effect. We also know, however, that such unfolding is an illusion. We know that the finished film links together shots that were taken in a much different sequence and then edited together to perform an arc. Scenes in the movie are likely re-shot and spliced together to provide the feeling of seamlessness. Music is added to give the work a texture of continuity—call it voice, call it “atmospherics.” All of these processes are in service of creating a “city outside” the mind that matches another “inside”—inside the mind of the director, inside the mind of the viewer as image matches image in the darkened room of the theater.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bang’s poem thrives on articulating the fragments and the fragmentary nature of such becoming. While there are moments that speak to narrative "), _c('a', {
    attrs: {
      "id": "page_44"
    }
  }), _vm._v("(“I remember the camera. / The clear click”), cause is not followed up by effect and narrative is deeply submerged. Instead of working through a trajectory of plot, the poem articulates the path of images unfolding unto other images. Instead of working with narrative logic, connections are made by visual association and sound:")]), _vm._v(" "), _c('div', {
    staticClass: "blockquotez"
  }, [_c('div', {
    staticClass: "blockquotez"
  }, [_c('div', {
    staticClass: "blockquotez"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("A face too small for this red mouth. Look how"), _c('br'), _c('br'), _vm._v("the line isn’t a street anymore"), _c('br'), _vm._v("but a track. Like that. The graveled"), _c('br'), _vm._v("shroud of a train. I’m not usually like"), _c('br'), _vm._v("this. A linkable Like arrives without its What."), _c('br'), _vm._v("Parks the car.")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("One thread through this poem is visual and progresses by noticing similarity of shape in unconnected things: the line made by the mouth’s lips becomes a line that was once a street but is now a track. This becomes a gravel shroud. Another thread tracks presence and absence: We see, in the mind, a street because we are told that it isn’t there anymore. The way that “I am” is defined by being “not like / this.” Linguistic play acts out the implied banter of “I’m not usually like this.” “Like what?” is the expected response, but here we are told that the “what” is absent—but in its absence it is figured: “A linkable Like arrives without its What. / Parks the car.” Here we have affirmation and acknowledgment that the comparison is not going to be fleshed out for us. Instead, we are given the presence of sound to pull us through the poem. Just as the visual line of flight takes off from the image of a mouth morphed into a street, a track, a gravel shroud, the long /ou/ sound of “mouth” and “how” is pulled through the “shroud” and subtly echoed by the long /ä/ repeated in “Parks the car.” And then there is the /ī/ present in “line,” “like,” “I’m,” “like,” and (again) “like.” Here, instead of being told or shown we are guided to "), _c('em', [_vm._v("hear")]), _vm._v(" the emphasis on comparison, so significant to the ekphrastic project, which necessarily asks such questions as: How does a film like “High Art” compare to life lived? Is it mimetic of the life, folding the construct of its making into the seamless possibility manufactured by a clever editor? In what way might a poem be “like” a film? In what way might they be like life?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("While the poem certainly does not answer these questions, it gives guidance at its center. Here are stanzas five and six, which share the exact center of the poem:")]), _vm._v(" "), _c('div', {
    staticClass: "blockquotez"
  }, [_c('div', {
    staticClass: "blockquotez"
  }, [_c('div', {
    staticClass: "blockquotez"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("from theory. Sexual configurations"), _c('br'), _vm._v("of glamour. What is the scene?"), _c('br'), _vm._v("what is the cover? The frozen waiting"), _c('br'), _vm._v("for focus and drive."), _c('br'), _vm._v("Look, look, look. Art is what"), _c('br'), _c('a', {
    attrs: {
      "id": "page_45"
    }
  }), _vm._v("looking takes you to. A red mouth"), _c('br'), _vm._v("opening to say,"), _c('br'), _vm._v("Don’t look away."), _c('br'), _vm._v("I’m not usually like this."), _c('br'), _vm._v("The camera sliding by with its aperture")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("At the heart of these central stanzas are the sentences “Look, look, look. Art is what // looking takes you to.” Enjambed over the hinge of white space that separates and connects this centrally placed moment, here we have an anchor, not only for the surrounding poem, but for the book as a whole.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The moment teaches us how to read the poem, for even in isolation, the lines angle out in multiple directions. First, there is the semantic state of the sentences: “Look, look, look” is a command directed both to the speaker of the poem and to the reader, rendering the poem performative. Bang commands “look,” and we have to realize that in some important sense, this is precisely what we are doing. To read is to look at letters on a page. To mouth the word “look,” thrice, is to speak with the sound of an emphatic blink. It is also to look at images created in the mind’s eye—and in the mind’s “I.” The second sentence is definitional: “Art is what”—suspended over the stanza’s hinge of white space, we wait to be told the “what” that it is. The fact that art is a “what” rather than a who or how implies, perhaps, that all looking results in art and that all looking requires the constructive action embodied by art.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Such a combination of narrative and non-narrative modes is significant not only for providing a variety of models for the forms of “living with” art that ekphrastic poetry can provide, but also because it strikes at the heart of the tension between absorption in artifice and insistence upon recognizing a poem’s construction. As Jonathan Culler notes in his essay “Why Lyric,” the New Critical lyric—and its reception by critics—has encouraged us to think of the lyric in fundamentally narrative terms. He contends that this tradition conceives of the lyric as “a fictional imitation of the act of a speaker, and to interpret the lyric is to work out what sort of person is speaking, in what circumstances and with what attitude or, ideally, drama of attitudes.”"), _c('a', {
    attrs: {
      "id": "en21"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en_21"
    }
  }, [_c('sup', [_vm._v("21")])]), _vm._v(" Such handling of the lyric foregoes thinking about the artifice of language in lieu of a psychological interpretation that is more apt, Culler claims, to works of fiction. This mode of interpretation not only asks lyric to perform as a genre it is entirely unsuited to, but also ignores its fundamental, and traditional, differences from narrative:")]), _vm._v(" "), _c('div', {
    staticClass: "blockquotez"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("Consider what the model of lyric as dramatic monologue misses: stress on the reconstruction of the dramatic situation deprives rhythm and sound patterning of any constitutive role (at best they reinforce or undercut meaning); it devalues intertextual relations, except when they can be assimilated to "), _c('a', {
    attrs: {
      "id": "page_46"
    }
  }), _vm._v("allusions made by the consciousness dramatized; and it ignores the characteristic extravagance of lyric, which frequently engages in speech acts without a known real-world counterpart."), _c('a', {
    attrs: {
      "id": "en22"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en_22"
    }
  }, [_c('sup', [_vm._v("22")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Culler ends his thoughts with a cry for criticism and pedagogy that revives a mode of study and teaching that foregrounds non-narrative aspects of the lyric, boldly asking us, in the end, to consider the lyric as something expansive enough to contain the absorption of narrative along with punctures of sound and allusion. Books such as Bang’s "), _c('em', [_vm._v("The Eye Like a Strange Balloon")]), _vm._v(", which so deftly navigate a range of such aspects, push us to see that such consideration is not only possible, but necessary.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("N MANY")]), _vm._v(" respects, "), _c('em', [_vm._v("Elegy")]), _vm._v(", Bang’s fifth book, comes as an anomaly in the trajectory formed by her work as it stretches from the circumscribed lyrics of "), _c('em', [_vm._v("Apology for Want")]), _vm._v(" to associative gestures, made in poems like “High Art,” which continue into her most recent work. Written during the year after the death of her adult son from an accidental overdose, "), _c('em', [_vm._v("Elegy")]), _vm._v(" is framed as autobiographical—a framework that Bang refuses to place on her other books. The mask of the persona is taken off, language has been pared down, and the subject of the book is an immediately concrete object: how to contend with loss’s grief and guilt, how to forge through the year of darkness that follows. However, if we are persuaded by Bernstein’s argument that all acts of language imply artifice, we will read "), _c('em', [_vm._v("Elegy")]), _vm._v(" as both emotionally absorptive utterance "), _c('em', [_vm._v("and")]), _vm._v(" utterance constructed from the conventions of tradition. Reading the book as such renders the work no less genuine, and viewing it through the lens of Bang’s relationship to artifice (rather than focusing solely on its devastating content) allows us to see the way "), _c('em', [_vm._v("Elegy")]), _vm._v(" resounds both apart from, and as part of, the trajectory of her work.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("Elegy")]), _vm._v(" employs many familiar concerns and techniques born of earlier projects. In most respects, the list of themes from "), _c('em', [_vm._v("Apology for Want")]), _vm._v(" are revisited here. However, as we will see, those themes are layered with a heightened sense of what is at stake when we engage in representation, and it is not difficult to see this aspect as a development from the work of "), _c('em', [_vm._v("The Eye Like a Strange Balloon")]), _vm._v(". While the mask of persona is off and the poems are spoken in propria persona, Bang still continues to complicate the notion of “speaker” by toggling back and forth between first and third person, rendering utterance now in the voice of “herself,” now in the voice that sees itself as an overt object in the distance. Ophelia, Mickey, and Alice are returned to, but where these figures served to highlight the artificiality of visual construction in work such as "), _c('em', [_vm._v("The Eye Like a Strange Balloon")]), _vm._v(", here they might read as contemporary mythological figures, in line with the elegiac tradition’s incorporation of myth. Oftentimes the figures stand "), _c('a', {
    attrs: {
      "id": "page_47"
    }
  }), _vm._v("in as gateway figures between past and present, childhood and adulthood, fiction and reality. For example, in the poem “Don’t,” Alice appears not as a literary figure, but as a real girl who was turned, by an author, into a literary figure: “Remember the cat Lewis Carroll sent / To look in on Alice at least once a week / As she found what she found // Difficult to decipher. A gesture / Of sympathy, yes, yet nowhere could she find comfort.”"), _c('a', {
    attrs: {
      "id": "en23"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en_23"
    }
  }, [_c('sup', [_vm._v("23")])]), _vm._v(" As with other books, the majority of the poems employ stanzas of equal numbers of lines with heavy enjambment and variable line and sentence length. Theater and film imagery abounds—the phrase “On the screen at the back of the [her] mind” appears in two different poems, “Waiting”"), _c('a', {
    attrs: {
      "id": "en24"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en_24"
    }
  }, [_c('sup', [_vm._v("24")])]), _vm._v(" and “Intractable, and Irreversible.”"), _c('a', {
    attrs: {
      "id": "en25"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en_25"
    }
  }, [_c('sup', [_vm._v("25")])]), _vm._v(" The poem “Blue Sky Elegy” gives us “The curtain comes down on the handcuffed one,”"), _c('a', {
    attrs: {
      "id": "en26"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en_26"
    }
  }, [_c('sup', [_vm._v("26")])]), _vm._v(" and in “Enclosure” we get the statement “I can no more understand the world as a stage.”"), _c('a', {
    attrs: {
      "id": "en27"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en_27"
    }
  }, [_c('sup', [_vm._v("27")])]), _vm._v(" Moments of ironic tone resonate with familiarity, though here poems are absent of Bang’s lighthearted play of wit. Comparison of moments such as, “For the ash in the box. The love of her life,” from the poem “Intractable, and Irreversible,”"), _c('a', {
    attrs: {
      "id": "en28"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en_28"
    }
  }, [_c('sup', [_vm._v("28")])]), _vm._v(" with lighter-hearted instances of irony evident in her other books allows such moments to doubly sound. The continuity of these gestures across projects—even in the midst of a life-changing event—implies that identity is composed of such action—that who we are depends on our techniques of figuring. As such, the articulations of "), _c('em', [_vm._v("Elegy")]), _vm._v(" are always imitations of the conventions of “elegy,” and if we want to locate the author, we must look to the signature of gesture and to the way in which she inhabits the conventions—the artifice—of the elegiac mode.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As Peter Sacks outlines in "), _c('em', [_vm._v("The English Elegy: Studies in the Genre from Spencer to Yeats")]), _vm._v(", elegy is “work”—by which he means both a literary product and, in the more dynamic sense, a working through of the grief experience."), _c('a', {
    attrs: {
      "id": "en29"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en_29"
    }
  }, [_c('sup', [_vm._v("29")])]), _vm._v(" The site of this work is the space between lived experience and the constructed artifice of language. Bang overtly recognizes this in her poem “The Role of Elegy” where she states that “The role of elegy is / To put a death mask on tragedy,”"), _c('a', {
    attrs: {
      "id": "en30"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en_30"
    }
  }, [_c('sup', [_vm._v("30")])]), _vm._v(" for elegy is kin to tragedy. As tragedy moves an audience to experience physical and emotional catharsis, elegy moves its maker toward life beyond death. This movement resonates with remarks Bang has made about the necessity for writing these poems. Not intending them for publication, working on the poems literally carried her through grief’s year."), _c('a', {
    attrs: {
      "id": "en31"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en_31"
    }
  }, [_c('sup', [_vm._v("31")])]), _vm._v(" It is interesting to note that such a stance is just as much a part of the tradition as its other conventions: poems of severe loss seem to require that their writers pen them "), _c('em', [_vm._v("as if")]), _vm._v(" it were only the act of writing that is at stake. Just as the elegiac poet must speak in propria persona, the poems must be a performance of not-wanting to perform.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("These notions of speaker and intention are only two of many tools of artifice fundamental to elegy’s catharsis: One of the central conventions of the elegiac genre is to transform the absent beloved into a symbol. And it "), _c('a', {
    attrs: {
      "id": "page_48"
    }
  }), _vm._v("is this symbol-making that allows the poem to do its life-work, for only after this transformation is grief accepted, allowing the one grieving to move on."), _c('a', {
    attrs: {
      "id": "en32"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en_32"
    }
  }, [_c('sup', [_vm._v("32")])]), _vm._v(" If we consider Mary Jo Bang as a poet of acceptance and resistance—a poet who creates with the tools of the lyric while revealing their artifice—it is this convention—the convention of symbolic figuring, of making artifice—that is most at issue in "), _c('em', [_vm._v("Elegy")]), _vm._v(". Here we find the “enforced accommodation between the mourning self on the one hand and the very words of grief and fictions of consolation on the other.”"), _c('a', {
    attrs: {
      "id": "en33"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en_33"
    }
  }, [_c('sup', [_vm._v("33")])]), _vm._v(" Throughout "), _c('em', [_vm._v("Elegy")]), _vm._v(" we see this struggle between poet and material—the need to articulate and a reluctance to use prepackaged language of grief to create a stand-in for her son.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The stakes, here, are quite stunning. On the one hand, to write about the loss of the other is to necessarily render the other into language, fixing the other into a system of symbols, into an aesthetic object. By such fixing, the lost one can be kept, at least in image, as monument. And, according to the elegiac tradition, such fixture is essential for the one in grief to move on. On the other hand, such fixing is problematic, an “aesthetization”")]), _vm._v(" "), _c('div', {
    staticClass: "blockquotez"
  }, [_c('div', {
    staticClass: "blockquotez"
  }, [_c('div', {
    staticClass: "blockquotez"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("Of loss, of the unbearable"), _c('br'), _vm._v("Afterimage of the once material."), _c('br'), _vm._v("To look for an imagined")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("Consolidation of grief"), _c('br'), _vm._v("So we can all be finished"), _c('br'), _vm._v("Once and for all and genuinely shut up"), _c('br'), _vm._v("The cabinet of genuine particulars."), _c('a', {
    attrs: {
      "id": "en34"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en_34"
    }
  }, [_c('sup', [_vm._v("34")])])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Here we see a recognition that such consolation is only imaginary, as opposed to actual, in the service of “shutting up” the nagging voice of guilt and grief, of effacing any “genuine” particular that might still attach to the beloved.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Landscape with the Fall of Icarus” squarely engages these problems of the aesthetic representation of the departed. The poem comes early in the book and illustrates techniques Bang uses to defray the cost of symbolism. In titling the poem after Breugel’s painting, which is itself a representation of the story of Daedalus and his son, Bang overtly layers the experience of the poem with the artifice of representation: Bang’s poem is ekphrastic of a painting that represents a myth that symbolizes both a son’s hubris and a parent’s failure to stop catastrophe. The poem begins with a blunt admission to such failure:")]), _vm._v(" "), _c('div', {
    staticClass: "blockquotez"
  }, [_c('div', {
    staticClass: "blockquotez"
  }, [_c('div', {
    staticClass: "blockquotez"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("How could I have failed you like this?"), _c('br'), _vm._v("The narrator asks")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("The object. The object is a box"), _c('br'), _vm._v("Of ashes. How could I not have saved you,")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_49"
    }
  }), _c('span', {
    staticClass: "font"
  }, [_vm._v("A boy made of bone and blood. A boy"), _c('br'), _vm._v("Made of a mind. Of years. A hand")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("And paint on canvas. A marble carving."), _c('br'), _vm._v("How can I not reach where you are")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("And pull you back. How can I be"), _c('br'), _vm._v("And you not. You’re forever on the platform"), _c('a', {
    attrs: {
      "id": "en35"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en_35"
    }
  }, [_c('sup', [_vm._v("35")])])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In addition to its title, the poem directly addresses the act of art making by testing out the equation of “son equals art” with the phrases “A boy / Made of mind. Of years. A hand // And paint on canvas. A marble carving.” However, this restless, fragmented listing action shows an inability—or an unwillingness—to settle on an aesthetic form. The poem ends with the desire that a “dolorous day” spent at the museum with her son be “Embedded in amber. / In garnet. In amber. In opal. In order // To keep going on.” Here we see a desire to render life into art so as to preserve a last moment, gesturing toward the elegiac tradition of turning the departed into a symbol. However, it is important to note that it is the “dolorous day” that Bang seeks to immortalize in opal artifice—not her son.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Employed here, and evident in other poems, is the blunt, raw, description of the actual physical state of the son as “ash in a box.” The relentless reduction and literalism of this phrase resists sentimentality and flies in the face of symbolization. Along these lines, throughout the book Bang takes care to never provide a physical description of her son and resists figuring him in general. We get small remnants such as articles of clothing: “Gray shirt, green pants”"), _c('a', {
    attrs: {
      "id": "en36"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en_36"
    }
  }, [_c('sup', [_vm._v("36")])]), _vm._v(" and “Unchangeable: that shirt, those summer pants. // That beautiful face.” Her son is allowed to speak in the poems, but words are air, echo chamber, and are not at risk for becoming stuck as symbolic figuration. Further, at one moment we think we will get a physical description, but the description folds into parody of symbol. The poem titled “Where Once” enjambs into the first line: “On the street, looking up, there you were” only to turn into the following line: “A single helium balloon, imagine / A flat-face mouse in Mylar.”"), _c('a', {
    attrs: {
      "id": "en37"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en_37"
    }
  }, [_c('sup', [_vm._v("37")])]), _vm._v(" Where we expected to come, at last, face to face with the son, we are given a Mickey Mouse balloon, a parody of a symbolic figure that is supposed, in the elegiac tradition, to take the place of the beloved.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Instead of objectifying her son, throughout "), _c('em', [_vm._v("Elegy")]), _vm._v(" Bang objectifies herself. In “Landscape with the Fall of Icarus,” we see this in her reference to herself as “the narrator.” Along with such gestures, throughout the book she refers to herself in the third person and often renders herself at a distance. In the poem “Intractable, and Irreversible” we get the phrase “I talk / But always to a mirror”"), _c('a', {
    attrs: {
      "id": "en38"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en_38"
    }
  }, [_c('sup', [_vm._v("38")])]), _vm._v(" and in “Words” the mirror imagery continues with “The self talking to a mirror.”"), _c('a', {
    attrs: {
      "id": "en39"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en_39"
    }
  }, [_c('sup', [_vm._v("39")])]), _vm._v(" In “What Is So Frightening,” "), _c('a', {
    attrs: {
      "id": "page_50"
    }
  }), _vm._v("Bang extends the distance implied by the mirror, doubling herself with the use of the third person and speaking of herself in the past tense, as if she is to herself only a distant memory: “There was / Someone like this before, she thought. // Upstanding, blank-faced, red-dressed. / Someone sitting in a box, defining herself / As one with roots.”"), _c('a', {
    attrs: {
      "id": "en40"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en_40"
    }
  }, [_c('sup', [_vm._v("40")])]), _vm._v(" This device reaches its deepest power at the heart of the book, where she figures herself with most distance. In the poem “ ‘In Order’ Means Neat and Not Next” Bang writes, “She was sitting next to herself in a seat / . . . These are my footprints, she thought, / Looking at her feet, Mary Jo’s in Mary Janes.”"), _c('a', {
    attrs: {
      "id": "en41"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en_41"
    }
  }, [_c('sup', [_vm._v("41")])]), _vm._v(" Here the distance is twofold; Bang not only figures herself in the third person, but presents this “she” in a moment of objectifying herself, of “sitting next to herself” and naming her feet “Mary Jo’s in Mary Janes”—rather than owning them as part of her body.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In one sense we can take this objectification as Bang’s desire to put herself in the place of her son—to have died in his place, saving him by taking on the solidity of the object in his name. There is also throughout "), _c('em', [_vm._v("Elegy")]), _vm._v(" an overt confession to a death wish—to become, herself, an object alongside her son. In “Words,” Bang writes, “I tell them / I wish I could lie under the summer”"), _c('a', {
    attrs: {
      "id": "en42"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en_42"
    }
  }, [_c('sup', [_vm._v("42")])]), _vm._v(" (note the resonance of Dickinson here), and in “What If” she states, “He’ll be obedient and she’ll be intractable / And dead. It’s all they ever wanted.”"), _c('a', {
    attrs: {
      "id": "en43"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en_43"
    }
  }, [_c('sup', [_vm._v("43")])]), _vm._v(" These moments chart the severity of the emotional moment, and the pressures of refusing to complete the process of grief. Instead of completing the separation between living and dead, life and object, Bang pleads to be as he is, so as to continue on.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If "), _c('em', [_vm._v("Elegy")]), _vm._v(" resolves this struggle between the artifice necessary to the grief process and resistance to giving her son over to such surface, it is through the symbol of the poem itself. Here, “poem” is imbued with the act of connection that seeks to communicate across time and space, that seeks to communicate to the self as other as well as to the lost son. As such, the poem, only a symbol, but as such, an apt vehicle, becomes loaded with the weight of the grief process. By transforming the lived, literal mother-son connection, lost with the loss of the son, into a symbolic connection carried on through the body of the poem, Bang does not resolve her grief but navigates it into the arena of the lyric sign called “poem” and “mourning song” and “book” with the sparest of titles, bared bones.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('em', [_vm._v("The Bride of E")]), _vm._v(", Bang’s sixth book, radiates with what comes after the ends of things, obsessively illuminating the static space that opens after radical fracture. While the book returns to a more overt foregrounding of artifice, it gathers significant resonance if read as poetry that has traversed "), _c('em', [_vm._v("Elegy")]), _vm._v(", for in this book Bang turns to the act of asking existential questions when the finish to the story, on both a personal and cultural level, is already known: “A blackout occurs and then we return to the routine: / "), _c('a', {
    attrs: {
      "id": "page_51"
    }
  }), _vm._v("The inhumane blather on the screen.”"), _c('a', {
    attrs: {
      "id": "en44"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en_44"
    }
  }, [_c('sup', [_vm._v("44")])]), _vm._v(" This blackout might stand for the deathly puncture of post-modern theory to lyric transparency, the blow to the American psyche of security that was 9/11, the death of a loved one—any catastrophe that ensures nothing can return to its former state.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Here, among the ruins, Bang asks such questions as “What is there to say” and “What is there to do” now that the postmodern condition—the death of god, the death of the author, the death of lyric subjectivity—has negated the possibility of addressing the existential. The book serves less to answer such questions (for they are ultimately resistant) than to develop tactics for articulating the state of needing to ask. Deeply saturated with the impossibility of such loss, "), _c('em', [_vm._v("The Bride of E")]), _vm._v(" assumes a sensibility that seeks significance nevertheless, for as we have seen in “B Is for Beckett,” “There is so little to say,” a statement that recognizes both the paucity of our post-postmodern condition, and the necessity for pushing into that “little” and saying it. Here we find ourselves inside poems pushing us “forward, into the fog, driving a golf cart, / A tear in the corner of your eye produced / In spite of the ironically undercut temple of truth.”"), _c('a', {
    attrs: {
      "id": "en45"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en_45"
    }
  }, [_c('sup', [_vm._v("45")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In both form and content the book foregrounds language as vehicle for questioning and organizing thought in this landscape of after. In a space where the narrative of cause and effect has come under suspicion, the book is an abecedarian, arranged according to the alphabet. The titles of the poems are mostly definitional (“C Is for Cher,” “B Is for Beckett,” etc.), drawing attention to the way in which we are indoctrinated into meaning, for it would be difficult to find an adult who grew up in the United States without having spent his or her grammar school years learning that “A is for Apple,” via a poster—featuring a brightly reddened apple—pinned to the schoolroom wall. By remembering the way we have been educated into language—through definition, memorization, and recitation—we can see that the concept of the dyadic sign is strictly banned (at least until college) and we are taught that a letter is part of a fundamental system wherein words equal objects out in the world. By employing this system and assigning more than one word to many letters in the alphabet (for example, “F Is for Forgetting” is followed by the titles “For Freud” and “For the Final Report”), Bang brings our attention to our own indoctrination and provides a method by which we might—through poetry—still manage to indoctrinate ourselves otherwise.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Further, Bang divides the book into two sections according to form. The first section, which at seventy-two pages takes the bulk of the eighty-five-page book, is composed of lineated verse and most often employs Bang’s signature fixed-line stanza and heavy enjambment. The second section of the book is composed of five prose poems that feature a more autobiographical intonation than the rest of the work. And, although there is continuity in linguistic texture across sections, the division implies that "), _c('a', {
    attrs: {
      "id": "page_52"
    }
  }), _vm._v("different forms afford accentuation of different content. By dividing her book in this way, Bang proposes that prose—and the blur of image and sound run together without the advantage of the line break—is the texture of the private self in existential question. And, by giving this private self only a little more than ten pages, she invites us to question what constitutes the bulk of our being: the quotidian, communal realm of language that, though valenced by individual experience, is shared; or the private self? In many ways it is ironic that Bang gives the more public, socially oriented section the lineation conventional of the lyric, and the private self—so long the territory of the tradition—the form of prose.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This notion that contemporary existential crisis is not a private condition but one born and felt through the individual inextricably intertwined with the public discourse of language, again evokes Samuel Beckett—the master of continuing on when one cannot. In "), _c('em', [_vm._v("The Theater of the Absurd")]), _vm._v(", Martin Esslin characterizes the way that such sensibility embodies the difficulty of language to express such a state, and his description, though of Beckett and of theater, is apt for the tensions Bang explores in the book:")]), _vm._v(" "), _c('div', {
    staticClass: "blockquotez"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("“anyone” who speaks is carried along by the logic of language and its articulation. Thus the writer who pits himself against the unsayable must use all his cunning so as not to say what the words make him say against his will, but to express instead what by their very nature they are designed to cover up: the uncertainty, the contradictory, the unthinkable."), _c('a', {
    attrs: {
      "id": "en46"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en_46"
    }
  }, [_c('sup', [_vm._v("46")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In response to such impossibility of expression, Bang relies on a cast of worn-out cultural icons, giving them lines of existential angst and questioning that can no longer be authentically asked. The book is populated with figures such as Mickey Mouse, Alice from Wonderland, Clark Kent, Jackie O, and Pee-Wee Herman. Accompanying them are Freud, Plato, Ophelia, Hamlet, and Eve, suggesting that icons of both high and low culture have been emptied of gravity but, as such, offer useful masks for articulating subjective searching that the poet cannot perform as herself. For example, in “C Is for Cher,” one of the first poems written for the book, Bang has Cher and Mickey say things that a contemporary poet is unable to say without sounding saccharine. Cher enters the beginning of the poem:")]), _vm._v(" "), _c('div', {
    staticClass: "blockquotez"
  }, [_c('div', {
    staticClass: "blockquotez"
  }, [_c('div', {
    staticClass: "blockquotez"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("Culture miniature and clad as Cleopatra, she descends"), _c('br'), _vm._v("A set of semicircular steps"), _c('br'), _vm._v("Tiled in a geometric mosaic pattern")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("And there she finds the answer: everything"), _c('br'), _vm._v("Changes depending on whether"), _c('br'), _vm._v("You’re up or down. Behind her,")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("A high-relief rectangle proscenium,"), _c('br'), _vm._v("Beside her, whatever intrigued her last."), _c('a', {
    attrs: {
      "id": "en47"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en_47"
    }
  }, [_c('sup', [_vm._v("47")])])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_53"
    }
  }), _vm._v("By setting the arrival at “the answer” in such a context, Bang is able to offer both a maxim that would sound unconvincing in an unmediated voice, and a critique of such (un)easy truths. Cher is clearly in the context of a stage set, and we cannot miss the irony of finding “the answer” in the mouth of Cher, made up as a faux Cleopatra, framed by a proscenium. Such answers may feel portentous in the moment, but are predestined to be discarded along with other things that “intrigued her last.” The remarkable thing about such moments in Bang’s work is that, while undercutting the seriousness of the answer, they don’t negate the sense that such answers have a glimmer of wisdom: Things "), _c('em', [_vm._v("do")]), _vm._v(" change depending on whether you’re up or down. Rather than casting such answers out as impossibly trivial, Bang layers the statement with the artificiality of cultural context, drawing attention to the way in which we are conditioned to trust and distrust such utterance.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Diving ever more deeply into the contemporary condition of postmodern artifice, Bang also navigates the problem of existential questioning by addressing the issue of language directly. For example, in “And as in Alice,” Alice from Wonderland is redeployed, but this time she is rejected (or, rather, she absents herself from the poem) as an adequate symbol:")]), _vm._v(" "), _c('div', {
    staticClass: "blockquotez"
  }, [_c('div', {
    staticClass: "blockquotez"
  }, [_c('div', {
    staticClass: "blockquotez"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("Alice cannot be in the poem, she says, because"), _c('br'), _vm._v("She’s only a metaphor for childhood"), _c('br'), _vm._v("And a poem is a metaphor already"), _c('br'), _vm._v("So we’d only have a metaphor")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("Inside a metaphor. Do you see?"), _c('br'), _vm._v("They all nod. They see. Except for the girl"), _c('br'), _vm._v("With her head in the rabbit hole. . . ."), _c('a', {
    attrs: {
      "id": "en48"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en_48"
    }
  }, [_c('sup', [_vm._v("48")])])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Here Bang marvelously and effectively navigates the problem of worn-out artifice. She deals with the issue directly: We know that Alice doesn’t exist, that she is just a literary/cultural metaphor. Further, when we compare contemporary evocation of Alice with Carroll’s complex philosophical and political landscape, we see how shallowly we evoke such symbols in contemporary culture. However, the fact that Alice has been such a reliable figure throughout Bang’s work makes her refusal to appear have enormous impact. Alice was there in "), _c('em', [_vm._v("The Eye Like a Strange Balloon")]), _vm._v(", shoring up the ruins of representation. In "), _c('em', [_vm._v("Elegy")]), _vm._v(", she appears to remind both speaker and reader of the complicated literary tradition of turning children—one’s own and others—into characters. Now, when we call on her again, she refuses to appear. She “cannot be in the poem.” What does she mean, she cannot be in the poem? By using a specific figure, such as Alice—and a figure that the reader of Bang’s work has history with—Bang is able to enact the intellectual and emotional impact of what, in the work "), _c('a', {
    attrs: {
      "id": "page_54"
    }
  }), _vm._v("of even the most inventive of postmodern theorists, comes across as speculative rather than felt.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The engine of this impact takes place most often in the form of unanswerable questions. In this way, the poems take up the tradition of the New Critical lyric, which foregrounds the concept of a speaker overheard, that is to say, of somebody speaking before a hidden audience. Take, for example, the poem “In the Present and Probable Future,” a poem that begins with a bird’s-eye view of things—“Here we are viewing the land: waves of grave and grain”—and arcs, over thirty lines later, into a post-apocalyptic moment where all that is left is “that unsullied moment, down to the last // Detail, when the acquired interview and other quaint signs of demise / Will speak about us to the flood and the fire.”"), _c('a', {
    attrs: {
      "id": "en49"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en_49"
    }
  }, [_c('sup', [_vm._v("49")])]), _vm._v(" With all of its beauty and stylization (such as the sentence “Cormorants on pitched roofs watch the ship of state mandate folded / twice over”), this is a speakerly poem that also encompasses colloquial phrases such as “Good luck with that,” giving us the feeling of being talked to or of overhearing a grandiloquent monologue. However, it is important to note that the speaker, here, is not an “I” overheard but a “we.” This punctures the domain of the New Critical lyric, so very centered around the individual, and asks that we reconsider what constitutes a speaker. Here the speaker is not so much an individual subjectivity, but the part of the self that engages in collective idea-making and action that is not separable from our modes of figuring—as the commonly used colloquial phrase “Good luck with that” proposes—but is part and parcel of it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Furthermore, within this arc Bang asks sixteen questions ranging from “When should we accept that life is only / An exaggerated form of special pleading, romanticized // Beyond saying into moon, stone, flock and trees?” to “What does it mean to have a point of view? What does it mean / To have a notable achievement? To succeed in representing // The nuances of a determinate activity?”"), _c('a', {
    attrs: {
      "id": "en50"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en_50"
    }
  }, [_c('sup', [_vm._v("50")])]), _vm._v(" Such questions encompass concerns that span from the generally existential to those that address the tradition of the lyric itself, for what is the New Critical lyric but success “in representing // The nuances of a determinate activity”—a “romanticized” “saying into moon, stone, flock and trees”? By commenting on the conventions of the poem from within the poem, Bang asks us to engage the poem as artifice while at the same time being swept up with the sincerity of its articulations: “Listen,” the poet says, about halfway through the poem, “however events turn out, if we want we can continue to see // The image of the moon as an outburst of lyric, a vision of John Keats / And his friends, but we still have the battle to fight.” Part of that battle, the poem contends, is seeing the moon not only as an outburst of lyric, but as an outburst that was constructed by a poetic tradition—and that is no less valuable for such a recognition, even though it asks us to remember that the moon we view is not "), _c('a', {
    attrs: {
      "id": "page_55"
    }
  }), _vm._v("only an object seen through a telescope, but also an image created with language.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("By foregrounding artifice, Bang not only mines tensions within the lyric tradition and between experimental and conventional notions of poem-making—but also foregrounds the tension between reading and writing. In many cases, Bang’s attention to artifice asks the reader to be flexible and to do connective work, actively recognizing allusions across and beyond her books, recognizing that the poet stands, in most instances, just off-stage, channeling her voice through various masks. These actions of noticing, connecting, and questioning are demanded by the poems, and are principle ways in which these poems mean.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Increasing emphasis on engaging active readers leads to a question of where “the lyric,” and its meaning, reside. Is the lyric in the poem itself, or is it in the eye of its beholder? Literary critics such as Paul de Man and Virginia Jackson propose that lyric is born in the process of reading. De Man takes this up as proof that there is no such thing as a lyric in and of itself, for, as he has famously stated, “no lyric can be read lyrically, nor can the object of a lyrical reading be itself a lyric.”"), _c('a', {
    attrs: {
      "id": "en51"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en_51"
    }
  }, [_c('sup', [_vm._v("51")])]), _vm._v(" Jackson arrives at similar ends by taking the opposite tactic and shows in her work on Emily Dickinson that “New Critical readings of texts like [Dickinson’s] ‘Further in Summer than the Birds’ created an abstract personification in place of the historical person, and consequently created an abstract genre accessible to all persons educated to read lyrically.”"), _c('a', {
    attrs: {
      "id": "en52"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en_52"
    }
  }, [_c('sup', [_vm._v("52")])]), _vm._v(" Lyric, then, is a readerly, editorial lens, and we might more productively classify strategies of “lyric reading” rather than look for lyric in poetic works.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Far from opposing this idea, Bang’s poetry renders these energies generative, not only by asking readers to engage in “lyric reading” that employs and challenges New Critical assumptions, but also by practicing a type of “lyric reading” that leaves lyric objects in her wake. Two recent projects that postdate "), _c('em', [_vm._v("The Bride of E")]), _vm._v("—a “slant” translation of Dante’s "), _c('em', [_vm._v("Inferno")]), _vm._v(" which will be published by Graywolf in 2012, and a series of poems that “write through” "), _c('em', [_vm._v("Mrs. Dalloway")]), _vm._v(", using only the words from Woolf’s text to construct new poems—extend Bang’s investment in language-as-source, deriving new texts from other’s works. For example, in “Opened and Shut,” from the Dalloway series, we see Bang’s heroine in a wholly different manner than we ever see Woolf’s, despite the fact that Bang’s poem is constructed of Woolf’s words: “Beautifully close up. And once, flames / eating the edge of the sofa. // Her eyelashes blurred. Chin, nose, forehead, / some lips.”"), _c('a', {
    attrs: {
      "id": "en53"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en_53"
    }
  }, [_c('sup', [_vm._v("53")])]), _vm._v(" Here, again, Bang absorbs us into the moment of her poem: Engaged in a dream of imaginative looking, transfixed by the conflagration, we are led to wonder if the blurring figure is woman or doll. At the same time, we might marvel at the art of such a construct: How does Bang "), _c('a', {
    attrs: {
      "id": "page_56"
    }
  }), _vm._v("manage to excise and weld such a scene from the monument of Woolf’s text? Such activity turns ever further into the material surface of language, exploring the way in which re-contextualization affects the sign, and the way in which attaching words to new signification overwrites, but does not efface, previous inscription. Indeed, here we are shown once again: Art is what looking takes us to.")]), _vm._v(" "), _c('h5', {
    staticClass: "h5"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("NOTES TO CRITICAL ESSAY")])]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "en_1"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en1"
    }
  }, [_vm._v("1.")]), _vm._v(" Mary Jo Bang, "), _c('em', [_vm._v("The Bride of E")]), _vm._v(" (Minneapolis, MN: Graywolf Press, 2009), 5.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "en_2"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en2"
    }
  }, [_vm._v("2.")]), _vm._v(" Mary Jo Bang, "), _c('em', [_vm._v("The Eye Like a Strange Balloon")]), _vm._v(" (New York: Grove Press, 2004), 12.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "en_3"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en3"
    }
  }, [_vm._v("3.")]), _vm._v(" See Moma.org for images from 1997 exhibition, sponsored by Madonna, of Moma’s collection of stills: "), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://www.moma.org/interactives/exhibitions/1997/Sherman",
      "target": "_blank"
    }
  }, [_vm._v("www.moma.org/interactives/exhibitions/1997/Sherman")])]), _vm._v(" (accessed May 30, 2010).")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "en_4"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en4"
    }
  }, [_vm._v("4.")]), _vm._v(" Northrop Frye, "), _c('em', [_vm._v("Anatomy of Criticism")]), _vm._v(" (New York, 1965), 249.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "en_5"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en5"
    }
  }, [_vm._v("5.")]), _vm._v(" Charles Bernstein, “Artifice of Absorption,” in "), _c('em', [_vm._v("A Poetics")]), _vm._v(" (Cambridge, MA: Harvard University Press, 1992), 29.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "en_6"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en6"
    }
  }, [_vm._v("6.")]), _vm._v(" Helen Vendler, “Introduction to The Harvard Book of Contemporary American Poetry,” quoted in Charles Bernstein, “Artifice of Absorption,” in "), _c('em', [_vm._v("A Poetics")]), _vm._v(" (Cambridge, MA: Harvard University Press, 1992), 41.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "en_7"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en7"
    }
  }, [_vm._v("7.")]), _vm._v(" Susan Schultz, “ ‘Called Null or Called Vocative’: A Fate of Contemporary Lyric.” "), _c('em', [_vm._v("Talisman")]), _vm._v(" 14 (1996): 70.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "en_8"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en8"
    }
  }, [_vm._v("8.")]), _vm._v(" Bang, "), _c('em', [_vm._v("The Bride of E")]), _vm._v(", 7.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "en_9"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en9"
    }
  }, [_vm._v("9.")]), _vm._v(" Samuel Beckett, "), _c('em', [_vm._v("Ohio Impromptu")]), _vm._v(", in "), _c('em', [_vm._v("Three Plays")]), _vm._v(" (New York: Grove Press, 1984),")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "en_10"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en10"
    }
  }, [_vm._v("10.")]), _vm._v(" Bernstein, “Artifice of Absorption,” 10.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "en_11"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en11"
    }
  }, [_vm._v("11.")]), _vm._v(" Stephen Burt, “My Name Is Henri,” in "), _c('em', [_vm._v("Close Calls with Nonsense")]), _vm._v(" (Saint Paul, MN: Graywolf Press, 2009), 138.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "en_12"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en12"
    }
  }, [_vm._v("12.")]), _vm._v(" Mary Jo Bang, "), _c('em', [_vm._v("The Downstream Extremity of the Isle of Swans")]), _vm._v(" (Athens: University of Georgia Press, 2004), 25.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "en_13"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en13"
    }
  }, [_vm._v("13.")]), _vm._v(" Ibid., 12.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "en_14"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en14"
    }
  }, [_vm._v("14.")]), _vm._v(" Ibid., 31.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "en_15"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en15"
    }
  }, [_vm._v("15.")]), _vm._v(" Mary Jo Bang, “Interview with Mary Jo Bang” by Jennifer K. Dick. Poets. org, "), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://www.poets.org/m/dsp_poem.php?prmMID=19940",
      "target": "_blank"
    }
  }, [_vm._v("www.poets.org/m/dsp_poem.php?prmMID=19940")])]), _vm._v(" (accessed May 24, 2011).")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "en_16"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en16"
    }
  }, [_vm._v("16.")]), _vm._v(" Donna Stonecipher, review of "), _c('em', [_vm._v("The Eye Like a Strange Balloon. Verse Magazine")]), _vm._v(" online, "), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://versemag.blogspot.com/2006/02/new-review-of-mary-jo-bang.html",
      "target": "_blank"
    }
  }, [_vm._v("http://versemag.blogspot.com/2006/02/new-review-of-mary-jo-bang.html")])]), _vm._v(" (accessed May 23, 2010).")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "en_17"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en17"
    }
  }, [_vm._v("17.")]), _vm._v(" Kellery, Lyn, “Poems Living with Paintings: Cole Swensen’s Ekphrastic Try.” "), _c('em', [_vm._v("Contemporary Literature")]), _vm._v(" 46, no. 2 (summer 2005), 180.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "en_18"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en18"
    }
  }, [_vm._v("18.")]), _vm._v(" Mary Jo Bang, "), _c('em', [_vm._v("The Eye Like a Strange Balloon")]), _vm._v(", 25.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "en_19"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en19"
    }
  }, [_vm._v("19.")]), _vm._v(" Mary Jo Bang, “Interview with Mary Jo Bang” by Jennifer K. Dick.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "en_20"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en20"
    }
  }, [_vm._v("20.")]), _vm._v(" Mary Jo Bang, "), _c('em', [_vm._v("The Eye Like a Strange Balloon")]), _vm._v(", 13.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "en_21"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en21"
    }
  }, [_vm._v("21.")]), _vm._v(" Jonathan Culler, “Why Lyric?” "), _c('em', [_vm._v("MLA")]), _vm._v(" 123, no. 1 (2008), 201.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "en_22"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en22"
    }
  }, [_vm._v("22.")]), _vm._v(" Ibid., 202.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "en_23"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en23"
    }
  }, [_vm._v("23.")]), _vm._v(" Mary Jo Bang, "), _c('em', [_vm._v("Elegy")]), _vm._v(" (Saint Paul, MN: Graywolf Press, 2007), 35.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "page_57"
    }
  }), _c('a', {
    attrs: {
      "id": "en_24"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en24"
    }
  }, [_vm._v("24.")]), _vm._v(" Ibid., 10.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "en_25"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en25"
    }
  }, [_vm._v("25.")]), _vm._v(" Ibid., 51.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "en_26"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en26"
    }
  }, [_vm._v("26.")]), _vm._v(" Ibid., 50.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "en_27"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en27"
    }
  }, [_vm._v("27.")]), _vm._v(" Ibid., 21.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "en_28"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en28"
    }
  }, [_vm._v("28.")]), _vm._v(" Ibid., 51.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "en_29"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en29"
    }
  }, [_vm._v("29.")]), _vm._v(" Peter Sacks, "), _c('em', [_vm._v("The English Elegy")]), _vm._v(" (Baltimore, MD: Johns Hopkins University Press, 1985), 2.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "en_30"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en30"
    }
  }, [_vm._v("30.")]), _vm._v(" Bang, "), _c('em', [_vm._v("Elegy")]), _vm._v(", 63.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "en_31"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en31"
    }
  }, [_vm._v("31.")]), _vm._v(" Personal correspondence.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "en_32"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en32"
    }
  }, [_vm._v("32.")]), _vm._v(" Sacks, "), _c('em', [_vm._v("English Elegy")]), _vm._v(", 5.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "en_33"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en33"
    }
  }, [_vm._v("33.")]), _vm._v(" Ibid., 2.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "en_34"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en34"
    }
  }, [_vm._v("34.")]), _vm._v(" Bang, "), _c('em', [_vm._v("Elegy")]), _vm._v(", 63.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "en_35"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en35"
    }
  }, [_vm._v("35.")]), _vm._v(" Ibid., 24.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "en_36"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en36"
    }
  }, [_vm._v("36.")]), _vm._v(" Ibid., 10.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "en_37"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en37"
    }
  }, [_vm._v("37.")]), _vm._v(" Ibid., 66.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "en_38"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en38"
    }
  }, [_vm._v("38.")]), _vm._v(" Ibid., 51.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "en_39"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en39"
    }
  }, [_vm._v("39.")]), _vm._v(" Ibid., 54.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "en_40"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en40"
    }
  }, [_vm._v("40.")]), _vm._v(" Ibid., 15.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "en_41"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en41"
    }
  }, [_vm._v("41.")]), _vm._v(" Ibid., 49.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "en_42"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en42"
    }
  }, [_vm._v("42.")]), _vm._v(" Ibid., 54.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "en_43"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en43"
    }
  }, [_vm._v("43.")]), _vm._v(" Ibid., 56.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "en_44"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en44"
    }
  }, [_vm._v("44.")]), _vm._v(" Bang, "), _c('em', [_vm._v("Elegy")]), _vm._v(", 15.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "en_45"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en45"
    }
  }, [_vm._v("45.")]), _vm._v(" Ibid., 29.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "en_46"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en46"
    }
  }, [_vm._v("46.")]), _vm._v(" Martin Esslin, "), _c('em', [_vm._v("The Theater of the Absurd")]), _vm._v(", (New York: Vintage Books, 2004), 38.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "en_47"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en47"
    }
  }, [_vm._v("47.")]), _vm._v(" Bang, "), _c('em', [_vm._v("The Bride of E")]), _vm._v(", 9.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "en_48"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en48"
    }
  }, [_vm._v("48.")]), _vm._v(" Ibid., 6.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "en_49"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en49"
    }
  }, [_vm._v("49.")]), _vm._v(" Ibid., 46–47.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "en_50"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en50"
    }
  }, [_vm._v("50.")]), _vm._v(" Ibid.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "en_51"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en51"
    }
  }, [_vm._v("51.")]), _vm._v(" Paul de Man, “Anthropomorphism and Trope in the Lyric,” in "), _c('em', [_vm._v("The Rhetoric of Romanticism")]), _vm._v(" (New York: Columbia University Press, 1984), 254.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "en_52"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en52"
    }
  }, [_vm._v("52.")]), _vm._v(" Virginia Jackson, "), _c('em', [_vm._v("Dickinson’s Misery: A Theory of Lyric Reading")]), _vm._v(" (Princeton, NJ: Princeton University Press, 2005), 100.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "en_53"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en53"
    }
  }, [_vm._v("53.")]), _vm._v(" Mary Jo Bang, "), _c('em', [_vm._v("Let’s Say Yes")]), _vm._v(" (New York: Handheld Editions, 2011).")]), _vm._v(" "), _c('h5', {
    staticClass: "h5a"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("BIBLIOGRAPHY")])]), _vm._v(" "), _c('h5', {
    staticClass: "h5b"
  }, [_c('em', [_vm._v("Books by Mary Jo Bang")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb"
  }, [_c('em', [_vm._v("Apology for Want")]), _vm._v(". Hanover, NH: University Press of New England/Middlebury College Press, 1997.")]), _vm._v(" "), _c('p', {
    staticClass: "hangb"
  }, [_c('em', [_vm._v("Louise in Love")]), _vm._v(". New York: Grove/Atlantic Press, 2001.")]), _vm._v(" "), _c('p', {
    staticClass: "hangb"
  }, [_c('em', [_vm._v("The Downstream Extremity of the Isle of Swans")]), _vm._v(". Athens: University of Georgia Press, 2001.")]), _vm._v(" "), _c('p', {
    staticClass: "hangb"
  }, [_c('em', [_vm._v("The Eye Like a Strange Balloon")]), _vm._v(". New York: Grove/Atlantic Press, 2004.")]), _vm._v(" "), _c('p', {
    staticClass: "hangb"
  }, [_c('em', [_vm._v("Elegy")]), _vm._v(". St. Paul, MN: Graywolf Press, 2007.")]), _vm._v(" "), _c('p', {
    staticClass: "hangb"
  }, [_c('em', [_vm._v("The Bride of E")]), _vm._v(". Saint Paul, MN: Graywolf Press, 2009.")]), _vm._v(" "), _c('p', {
    staticClass: "hangb"
  }, [_c('em', [_vm._v("Dante’s Inferno: A New Version")]), _vm._v(". Saint Paul, MN: Graywolf Press, 2012.")]), _vm._v(" "), _c('h5', {
    staticClass: "h5b"
  }, [_c('a', {
    attrs: {
      "id": "page_58"
    }
  }), _c('em', [_vm._v("Chapbooks")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb"
  }, [_c('em', [_vm._v("Her Head in a Rabbit Hole")]), _vm._v(". New York: Delirium Press, 2006.")]), _vm._v(" "), _c('p', {
    staticClass: "hangb"
  }, [_c('em', [_vm._v("Let’s Say Yes")]), _vm._v(". Brooklyn, NY: Handheld Editions, 2011.")]), _vm._v(" "), _c('h5', {
    staticClass: "h5b"
  }, [_c('em', [_vm._v("Bilingual Editions")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb"
  }, [_c('em', [_vm._v("Elegia (Elegy)")]), _vm._v(", bilingual edition, Spanish/English, translation and prologue by Jaime Priede. Madrid, Spain: Bartleby Editores, 2010.")]), _vm._v(" "), _c('p', {
    staticClass: "hangb"
  }, [_c('em', [_vm._v("Eskapaden. Gedichte (Escapades: Poems)")]), _vm._v(", bilingual edition, German/English. Weisbaden, Germany: Lux Books, 2010.")]), _vm._v(" "), _c('h5', {
    staticClass: "h5b"
  }, [_c('em', [_vm._v("Selected Interviews")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb"
  }, [_vm._v("With Susie DeFord, “Mary Jo Bang: The Bride of Alliteration,” "), _c('em', [_vm._v("Bomb Magazine")]), _vm._v(", October 5, 2009, "), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://www.bombsite.com",
      "target": "_blank"
    }
  }, [_vm._v("www.bombsite.com")])]), _vm._v(" (accessed May 27, 2010).")]), _vm._v(" "), _c('p', {
    staticClass: "hangb"
  }, [_vm._v("With Jennifer K. Dick, “The World Anew: Mary Jo Bang and Jennifer K. Dick in Conversation,” "), _c('em', [_vm._v("Verse")]), _vm._v(" 22, no. 1 (2005).")]), _vm._v(" "), _c('p', {
    staticClass: "hangb"
  }, [_vm._v("With Vincent Guerra, “Mary Jo Bang: Interviewed by Vincent Guerra,” "), _c('em', [_vm._v("Southeast Review")]), _vm._v(", February 1, 2010.")]), _vm._v(" "), _c('p', {
    staticClass: "hangb"
  }, [_vm._v("With Jennifer Kronovet, “A Talk with Mary Jo Bang,” "), _c('em', [_vm._v("Stop Smiling Magazine")]), _vm._v(", no. 34 (March 2008).")]), _vm._v(" "), _c('h5', {
    staticClass: "h5b"
  }, [_c('em', [_vm._v("Selected Criticism")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb"
  }, [_vm._v("Ashley, Renée. Review of "), _c('em', [_vm._v("The Bride of E. Literary Review")]), _vm._v(" 53, no. 3 (Spring 2010): 218–26.")]), _vm._v(" "), _c('p', {
    staticClass: "hangb"
  }, [_vm._v("Bar-Nadav, Hadara. “A Little Light: Mary Jo Bang and the State of the Elegy.” "), _c('em', [_vm._v("New Letters")]), _vm._v(" 74, no. 4 (2008): 207.")]), _vm._v(" "), _c('p', {
    staticClass: "hangb"
  }, [_vm._v("Bar-Nadav, Hadara. “Sex with an Effigy.” "), _c('em', [_vm._v("American Book Review")]), _vm._v(" 27, no. 1 (November/December 2005): 28–29.")]), _vm._v(" "), _c('p', {
    staticClass: "hangb"
  }, [_vm._v("Bendall, Molly. Review of "), _c('em', [_vm._v("Louise in Love. Prairie Schooner")]), _vm._v(" 77, no. 3 (Fall 2003): 185–88.")]), _vm._v(" "), _c('p', {
    staticClass: "hangb"
  }, [_vm._v("Biespiel, David. “Free-Verse Styles.” "), _c('em', [_vm._v("Sewanee Review")]), _vm._v(" 111, no. 3 (Summer 2003): 470–79.")]), _vm._v(" "), _c('p', {
    staticClass: "hangb"
  }, [_vm._v("Burt, Stephen. “My Name Is Henri: Contemporary Poets Discover John Berryman.” In "), _c('em', [_vm._v("Close Calls with Nonsense: Reading New Poetry")]), _vm._v(". Saint Paul, MN: Graywolf Press, 2009: 129–43.")]), _vm._v(" "), _c('p', {
    staticClass: "hangb"
  }, [_vm._v("Cihlar, James. Review of "), _c('em', [_vm._v("The Bride of E. Coldfront Magazine")]), _vm._v(", January 28, 2010, "), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://coldfrontmag.com/tag/mary-jo-bang",
      "target": "_blank"
    }
  }, [_vm._v("http://coldfrontmag.com/tag/mary-jo-bang")])]), _vm._v(" (accessed May 28, 2010).")]), _vm._v(" "), _c('p', {
    staticClass: "hangb"
  }, [_vm._v("Etter, Carrie. “No Comfort.” "), _c('em', [_vm._v("Times Literary Supplement")]), _vm._v(" ("), _c('em', [_vm._v("TLS")]), _vm._v(") (London), March 6, 2009, 25.")]), _vm._v(" "), _c('p', {
    staticClass: "hangb"
  }, [_vm._v("Fischer, Barbara. “Object Relations.” "), _c('em', [_vm._v("Boston Review")]), _vm._v(", September/October 2005, "), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://bostonreview.net/BR30.5/fischer.php",
      "target": "_blank"
    }
  }, [_vm._v("http://bostonreview.net/BR30.5/fischer.php")])]), _vm._v(" (accessed June 23, 2010).")]), _vm._v(" "), _c('p', {
    staticClass: "hangb"
  }, [_vm._v("Kelsey, Karla. Review of "), _c('em', [_vm._v("The Bride of E. Constant Critic")]), _vm._v(", ConstantCritic.com, June 27, 2010, "), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://www.constantcritic.com/karla_kelsey/the-bride-of-e",
      "target": "_blank"
    }
  }, [_vm._v("www.constantcritic.com/karla_kelsey/the-bride-of-e")])]), _vm._v(" (accessed July 2, 2010).")]), _vm._v(" "), _c('p', {
    staticClass: "hangb"
  }, [_vm._v("Kirby, David. “Books in Brief Fiction & Poetry: ‘Give Me Rapture and Bliss.’ ” "), _c('em', [_vm._v("New York Times Book Review")]), _vm._v(", March 4, 2001, 23.")]), _vm._v(" "), _c('p', {
    staticClass: "hangb"
  }, [_c('a', {
    attrs: {
      "id": "page_59"
    }
  }), _vm._v("Neely, Mark. “Gestures Toward the Universe.” "), _c('em', [_vm._v("Jacket Magazine")]), _vm._v(", no. 16 (March 2002), "), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://www.jacketmagazine.com/16/neely.html",
      "target": "_blank"
    }
  }, [_vm._v("www.jacketmagazine.com/16/neely.html")])]), _vm._v(" (accessed July 2, 2010).")]), _vm._v(" "), _c('p', {
    staticClass: "hangb"
  }, [_vm._v("Orr, David. “In Memoriam.” "), _c('em', [_vm._v("New York Times Book Review")]), _vm._v(", March 30, 2008, 6.")]), _vm._v(" "), _c('p', {
    staticClass: "hangb"
  }, [_vm._v("Rauschenbusch, Stephanie. “Radical Originality.” "), _c('em', [_vm._v("American Book Review")]), _vm._v(" 23 (July/August 2002): 18.")]), _vm._v(" "), _c('p', {
    staticClass: "hangb"
  }, [_vm._v("Sadoff, Ira. “Flat Death’: Irretrievable Loss in Three Contemporary Poets.” "), _c('em', [_vm._v("Kenyon Review")]), _vm._v(" 31, no. 3 (summer 2009): 188–99.")]), _vm._v(" "), _c('p', {
    staticClass: "hangb"
  }, [_vm._v("Solomon, Laura. Review of "), _c('em', [_vm._v("Louise in Love. Verse")]), _vm._v(" 18 (2001): 189–90.")]), _vm._v(" "), _c('p', {
    staticClass: "hangb"
  }, [_vm._v("Stonecipher, Donna. Review of "), _c('em', [_vm._v("The Eye Like a Strange Balloon. Verse Magazine")]), _vm._v(" (online edition), "), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://versemag.blogspot.com/2006/02/new-review-of-mary-jo-bang.html",
      "target": "_blank"
    }
  }, [_vm._v("http://versemag.blogspot.com/2006/02/new-review-of-mary-jo-bang.html")])]), _vm._v(" (accessed February 9, 2006).")]), _vm._v(" "), _c('p', {
    staticClass: "hangb"
  }, [_vm._v("Treseler, Heather. “Demeter’s Song.” "), _c('em', [_vm._v("Notre Dame Review")]), _vm._v(", 26 (Summer/Fall 2008): 237–45.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a521264","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter1_k.vue
// module id = 117
// module chunks = 0